import Base from './Base';
import Events from '../events/Events';
import EventDispatcher from '../events/EventDispatcher';
import ValidateCheckout from './vip/checkout/ValidateCheckout';
import Success from './vip/Success';
import swal from 'sweetalert';
/**
 * The Vip page.
 *
 * @copyright Swoo Inc
 * @website http://swoo.ca
 * @author Jonathan Simard <jonathan@swoo.ca>
 */
export default class Vip extends Base{

	init(id,view,lang){
		console.log('Vip :: init');

        this.view               = view;
        this.lang               = document.documentElement.getAttribute('lang');
        this.submitBt           = this.view.querySelector('button[type="submit"]');
        this.formMessage        = this.view.querySelector('.formMessage');
        this.isProcessing       = false;
        this.terms 				= this.view.querySelector('#terms');
        this.totalLeft			= this.view.querySelector('.block_total .left');
        // this.totalRight			= this.view.querySelector('.block_total .right .total');
        // this.st					= this.totalLeft.querySelector('.st span:last-child');
        this.form               = {
            lang: this.lang,
        }

        //Stripe mounting
        // this.stripe         = Stripe('pk_test_AbX9RYJZi3eXIdp7dTRCpFHx');
        this.stripe         = Stripe('pk_live_x1dA9xgmUV4kDuV6Gl4k0ZmC');
        const elements      = this.stripe.elements({
            locale:this.lang
        });
        this.cardNumber    = elements.create('cardNumber');
        this.cardExpiry    = elements.create('cardExpiry');
        this.cardCvc       = elements.create('cardCvc');
        this.cardName      = this.view.querySelector('#card_name');

        this.cardNumber.mount('#form_card_number');
        this.cardExpiry.mount('#form_card_expiry');
        this.cardCvc.mount('#form_card_cvv');

        this.validateCheckout 	= new ValidateCheckout(this.view);
        this.success            = new Success(this.view.querySelector('.thx'));                        

        if (this.terms)
            this.terms.addEventListener('change', this.onCheckTerms.bind(this));

        this.submitBt.addEventListener('click', this.submitForm.bind(this));

        window.addEventListener(Events.Checkout.SUCCESS, this.checkoutSuccess.bind(this));
        window.addEventListener(Events.Form.SUCCESS, this.formSuccess.bind(this));
        window.addEventListener(Events.Form.ERROR, this.formError.bind(this));
    }

    checkoutSuccess(e){
        let checkoutForm = e.detail;

        document.querySelector('#vipForm').parentNode.classList.add('load');
        this.stripe.createToken(this.cardNumber, {name: this.cardName.value}).then((result)=> {
            if(result.token){
                this.formMessage.classList.add('hidden');
                //merge
                Object.assign(this.form, checkoutForm);

                this.form.token = result.token.id;
                this.success.cardBrand = result.token.card.brand;
                this.success.card4LastNumb = result.token.card.last4;
                this.sendCheckoutInfos();
            }else{
                this.formMessage.classList.remove('hidden');
                this.formMessage.innerHTML = result.error.message;
                document.querySelector('#vipForm').parentNode.classList.remove('load');
            }
        });

    }

    compileParams(data){
        let response = [];

        Object.keys(data).forEach(prop =>{
            response.push(prop + '=' + data[prop]);
        });

        return response.join('&');
    }

    formSuccess(response){
        console.log(response);

        if(response.detail.success){
            this.view.querySelector('.step.step_5').classList.add('hidden');
            this.view.querySelector('.thx').classList.add('active');
            this.success.load(response.detail);
        }else{
            this.formMessage.classList.remove('hidden');
            this.formMessage.innerHTML = response.detail.message;
        }
    }

    formError(response){
    	console.log(response);

	    this.formMessage.classList.remove('hidden');
	    this.formMessage.innerHTML = response.detail.message;
    }

    onCheckTerms(e){
    	e.preventDefault();
    	
    	if(e.target.checked) this.validateCheckout.formValidate.terms = true;
    	else this.validateCheckout.formValidate.terms = false;

    }

    onCompleteCheckout(response){
        console.log("ValidateCheckout :: onCompleteCheckout :: ",response);
        document.querySelector('#vipForm').parentNode.classList.remove('load');
        if(response){
           EventDispatcher.trigger(window, Events.Form.SUCCESS, true, true, response);
        }else console.error('ValidateCheckout :: response.success == false');
    }

    onRSC(event){
        // Request is not ready yt
        const xhr = event.target;

        if(xhr.readyState != XMLHttpRequest.DONE)
            return;

        try{
            const data = JSON.parse(xhr.responseText);
            this.onCompleteCheckout(data);
            this.sending = false;

        }catch(e){ console.error('ValidateCheckout :: onRSC :: error ::', event); }
    }

    sendCheckoutInfos(){
        console.log("ValidateCheckout :: sendCheckoutInfos");
        if(!this.sending){
            this.sending = true;
            const xhr = new XMLHttpRequest();
            xhr.open('POST', 'wp-admin/admin-ajax.php?action=vip_checkout', true);
            xhr.onreadystatechange = this.onRSC.bind(this);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            xhr.send(this.compileParams(this.form));
        }else {
            document.querySelector('#vipForm').parentNode.classList.remove('load');
        	console.log('ValidateCheckout :: was already sending');
        }
    }

    submitForm(e){
    	e.preventDefault();
    	
    	this.validateCheckout.validate();
    }
}